import {Button} from "react-bootstrap";

const ExpiredSessionModal = ({ handleClose }) => {
    return (
        <div className={"d-flex flex-column justify-content-around align-items-center"}>
            <h3 className={"fw-bold text-danger"}>
                Your Session has been expired
            </h3>
            <p className={"text-secondary"}>
                Please login again
            </p>
            <div className={"d-flex justify-content-center"}>
                <Button variant={"secondary"} className={"me-2"} onClick={handleClose}>
                    Login
                </Button>
            </div>
        </div>
    );
};

export default ExpiredSessionModal;
